import { InboxIcon } from 'lucide-react';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';

export default function ClubEmptyList({ title = 'Nenhum item na lista', description }) {
    return (
        <Empty className="border-0 py-10">
            <EmptyHeader>
                <EmptyMedia variant="icon">
                    <InboxIcon />
                </EmptyMedia>
                <EmptyTitle>{title}</EmptyTitle>
                {description ? <EmptyDescription>{description}</EmptyDescription> : null}
            </EmptyHeader>
        </Empty>
    );
}
